import { render, staticRenderFns } from "./ProcessProps.vue?vue&type=template&id=669f8591"
import script from "./ProcessProps.vue?vue&type=script&lang=js"
export * from "./ProcessProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports